import api from '@/services/api'
import localforage from 'localforage'

// Los PDF van fuera de Vuex: vuex-persist reescribe el estado entero en cada
// mutación y un PDF en base64 lo haría inviable (docs/deca/00-INVENTARIO-MOVIL.md §5.1).
const pdfs = localforage.createInstance({ name: 'gecotrail-deca', storeName: 'pdf' })

class Deca {
  /** Emite (o recupera) el DeCA de la ruta. payload: { ruta_id, fecha, vehiculo_id?, cisterna_id?, remolque_id } */
  async iniciarJornada(payload) {
    const { data } = await api.post('deca/jornada', payload)
    return data
  }

  /** Consulta sin emitir: { requerido, deca|null } */
  async consultar(rutaId, fecha) {
    const { data } = await api.get('deca/jornada', { params: { ruta_id: rutaId, fecha } })
    return data
  }

  /** Descarga el PDF vigente y lo guarda junto al sha256 con el que se pidió (revisiones: docs/specs/deca.md §14). */
  /** Foto de lo recogido sin enviar: el servidor revisa el DeCA. payload: { ruta_id, fecha, lineas: [{explotacion_codigo, litros}] } */
  async progreso(payload) {
    const { data } = await api.post('deca/progreso', payload)
    return data
  }

  async descargarPdf(id, sha256 = null) {
    const { data } = await api.get(`deca/${id}/pdf`, { responseType: 'blob' })
    await pdfs.setItem(String(id), { sha256, blob: data })
    return data
  }

  async pdf(id) {
    const item = await pdfs.getItem(String(id))
    // Formato anterior a las revisiones: el Blob suelto, sin sha256.
    return item?.blob ?? (item instanceof Blob ? item : null)
  }

  /** sha256 del PDF guardado en el móvil, o null si no hay o es de antes de las revisiones. */
  async sha256Guardado(id) {
    return (await pdfs.getItem(String(id)))?.sha256 ?? null
  }

  /** Borra los PDF que ya no corresponden a ningún DeCA guardado. */
  async purgar(idsVigentes) {
    const vigentes = idsVigentes.map(String)
    const claves = await pdfs.keys()
    await Promise.all(claves.filter(k => !vigentes.includes(k)).map(k => pdfs.removeItem(k)))
  }
}

export default new Deca()
